import React, { Component } from 'react';
import{
    Container,
    Col,
    Row,
    Button,
    Form,
    Input,
    Table
} from 'reactstrap';
import {withRouter} from 'react-router-dom';
import { Search } from '../components/Search';
import { OrdiniFilter } from '../components/StoricoOrdine/OrdiniFilter'


/**
 * Used for the Listino Prezzi section. 
 */
class StoricoVersamentoContainer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            versamenti: [],
            totalVersamenti: 0,
            numPerPage: 5,
            totalPages: 0,
            changeNumPerPage: 0,
            pageNum: 1,   
            searchText: "",   
            dataDa: "",
            dataA: "",
            importoDa: "",
            importoA: "",
            codFisc: "",
            cliente: "",
            stato: "",
            historicalFilter: {
                dataDa: "",
                dataA: "",
                importoDa: "",
                importoA: "",
                codFisc: "",
                cliente: "",
                stato: "",
            }          
        };
    }

    componentDidMount() {
        this.getVersamenti();
    }


    componentWillUnmount(){
        
    }

    getVersamenti = () => {
        const form = {
            searchText: this.state.searchText,   
            dataDa: this.state.dataDa,
            dataA: this.state.dataA,
            importoDa: this.state.importoDa,
            importoA: this.state.importoA,
            codFisc: this.state.codFisc,
            cliente: this.state.cliente,
            stato: this.state.stato, 
            numPerPage: this.state.numPerPage,
            pageNum: this.state.pageNum
        }

        fetch(`/api/versamenti/storico`, {   
            method: 'POST',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
                //Sets the content type. Necessary for the server to recognize the information
                'Content-Type': 'application/json' 
            }),
            //Sets the body of the call
            body: JSON.stringify(form)
            //Changes the response to an object
        }).then(response => response.json())
        .then(myjson => {
            if(!myjson.error){       
                this.setState({
                    versamenti: myjson.versamenti,
                    totalVersamenti: myjson.totalVersamenti,
                    totalPages: myjson.totalPages,
                    numPerPage: myjson.totalVersamenti < this.state.numPerPage ? myjson.totalVersamenti : this.state.numPerPage
                })
            }
            else{
                this.setState({
                    versamenti: [],
                    totalVersamenti: 0,
                    numPerPage: 5,
                    totalPages: 0,
                })
            }
        }).catch(e => {

        });
    }

    handleButtonChangeNumPerPage = (num) => {
        const newNumPerPage = ((this.state.numPerPage + num) > 0) && ((this.state.numPerPage + num) <= this.state.totalVersamenti) ? (this.state.numPerPage + num) : this.state.numPerPage;
       
        if(newNumPerPage !== this.state.numPerPage){
            this.setState({
                numPerPage: newNumPerPage,
                pageNum: newNumPerPage >= this.state.totalVersamenti && this.state.pageNum !== 1 ? this.state.pageNum-1 : this.state.pageNum
            }, () => this.getVersamenti());
        }
        else if(this.state.numPerPage > this.state.totalVersamenti){
            if(num < 0){
                this.setState({
                    numPerPage: this.state.numPerPage + num,
                });
            }
            
        }
    }

    handleInputChangeNumPerPage = (e) => {
        e.preventDefault(e);

        const isNum = /^\d+$/.test(e.target.value);

        if(isNum){
            this.setState({
                numPerPage: parseInt(e.target.value, 10)  
            });
        }
        else if(e.target.value === ''){
            this.setState({
                numPerPage: e.target.value,
            })
        }
    }

    handleNumPerPageSubmit = (e) => {
        e.preventDefault();

        if(this.state.numPerPage >= this.state.totalVersamenti){
            this.setState({
                pageNum: 1,
                numPerPage: this.state.totalVersamenti
            }, () => this.getVersamenti())
        }
        else{
            this.setState({
                pageNum: 1,
            }, () => this.getVersamenti())
        }
    }

    handleSearchChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleSearchSubmit = (e) => {
        e.preventDefault();
    
        this.getVersamenti();
    } 

    handlePrev = (e) => {
        this.setState({
            pageNum: this.state.pageNum - 1
        }, () => this.getVersamenti());
    }

    handleNext = (e) => {
        this.setState({
            pageNum: this.state.pageNum + 1
        }, () => this.getVersamenti());
    }

    handleFilterChange = (e) => {    
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    handleFilterCancel = () => {
        this.setState({
            dataDa: this.state.historicalFilter.dataDa,
            dataA: this.state.historicalFilter.dataA,
            importoDa: this.state.historicalFilter.importoDa,
            importoA: this.state.historicalFilter.importoA,
            codFisc: this.state.historicalFilter.codFisc,
            cliente: this.state.historicalFilter.cliente,
            stato: this.state.historicalFilter.stato,
        })
    }

    handleFilterSubmit = () => {

        this.setState({
            historicalFilter: {
                dataDa: this.state.dataDa,
                dataA: this.state.dataA,
                importoDa: this.state.importoDa,
                importoA: this.state.importoA,
                codFisc: this.state.codFisc,
                cliente: this.state.cliente,
                stato: this.state.stato,
            },
            numPerPage: this.state.pageNum >= 5 ? this.state.pageNum : 5
        }, () => this.getVersamenti())
    }

    getPdf = (e, id) => {
        e.preventDefault();

        fetch(`../api/clienti/fatture/${id}`, {   
            method: 'Get',
            headers: new Headers({
                //Authorization token
                'Authorization': 'Bearer ' + sessionStorage.getItem("auth"),
            }),
            //Changes the response to an object
        }).then(response => response.blob())
        .then(blob => {
            window.open(URL.createObjectURL(blob))
        }).catch(e => {
            console.log(e);
        });

    }

    /**
     * Renders the page
     */
    render() {
        const titolo = (
            <Container className="d-flex align-items-center justify-content-center" style={{paddingBottom: "15px"}} fluid>
                <Row className="d-flex" style={{margin: "0px", width: "100%"}}>
                    <Col xs={{size: 12, order: 2}} md={{size: 3, order: 1}} className="d-flex align-items-center justify-content-md-start justify-content-center pl-md-0 mb-2 mb-md-0" >
                        <Form className="form" onSubmit={this.handleNumPerPageSubmit}>
                            <Row className="d-flex align-items-center" >  
                                <Col className=" d-flex justify-content-end col-4" style={{padding: "0px", marginRight: "0px", height: "40px"}}>
                                    <Button onClick={() => this.handleButtonChangeNumPerPage(-1)} style={{height: "100%", width: "100%", padding: "0px", borderTopLeftRadius : "25px", borderWidth: "medium", borderBottomLeftRadius : "25px", borderTopRightRadius: "0px", borderBottomRightRadius: "0px", color: "#011e41", borderColor: "#011e41", backgroundColor: "transparent", borderRight: "0px", fontSize: "25px", verticalAlign:"middle", textAlign: "center", fontWeight: "bold"}}>-</Button>
                                </Col>
                                <Col className="d-flex justify-content-center col-4" style={{padding: "0px", marginLeft: "0px", marginRight: "0px", height: "40px"}}>
                                    {this.state.totalVersamenti === 0 ? 
                                        <Input id="numPerPage" name="numPerPage" type="text" className="form-control" value={this.state.numPerPage} onChange={this.handleInputChangeNumPerPage} style={{width: "100%", height: "100%", padding: "0px", borderWidth: "medium", borderRadius: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/> :
                                        <Input id="numPerPage" name="numPerPage" type="text" className="form-control" value={this.state.numPerPage} onChange={this.handleInputChangeNumPerPage} style={{width: "100%", height: "100%", padding: "0px", borderWidth: "medium", borderRadius: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/>}
                                </Col>
                                <Col className=" d-flex justify-content-start col-4" style={{padding: "0px", marginRight: "0px", height: "40px"}}>
                                    <Button onClick={() => this.handleButtonChangeNumPerPage(1)} style={{height: "100%", width: "100%", padding: "0px", borderWidth: "medium", borderTopRightRadius : "25px", borderBottomRightRadius : "25px", borderTopLeftRadius: "0px", borderBottomLeftRadius: "0px", color: "#011e41", borderColor: "#011e41", backgroundColor: "transparent", borderLeft: "0px", fontSize: "25px", verticalAlign:"middle", textAlign: "center", fontWeight: "bold"}}>+</Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                    <Col xs={{size: 12, order: 1}} md={{size: 6, order: 2}} className="d-flex align-items-center justify-content-center mb-2 mb-md-0">
                        <h5 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Storico Versamenti</h5>
                    </Col>
                    <Col xs={{size: 12, order: 3}} md={{size: 3, order: 3}} className="d-flex align-items-center justify-content-md-end justify-content-center pr-md-0" >  
                        <Container>
                            <Row style={{marginBottom: "5px"}}>
                                <Col>
                                    <Search text={this.state.searchText} handleSearchChange={this.handleSearchChange} handleSearchSubmit={this.handleSearchSubmit} />
                                </Col>
                            </Row>
                            <Row>
                                <Col style={{padding: "0"}}>
                                    <OrdiniFilter annulla={this.handleFilterCancel} vai={this.handleFilterSubmit}>
                                        <Container>
                                            <Row>
                                                <Col className="d-flex align-items-center justify-content-start">
                                                    <h3 style={{color: "#011e41", fontWeight: "bold", fontSize:"35px", margin: "0px"}}>Data:</h3>
                                                </Col>
                                            </Row>
                                            <Row style={{marginBottom: "5px", height: "90%"}}>
                                                <Col sm={2} className="d-flex align-items-center justify-content-start">
                                                    <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>da:</h4>                                                    
                                                </Col>
                                                <Col sm={6} className="d-flex align-items-center justify-content-start">
                                                    <Input id="dataDa" name="dataDa" type="date" onChange={this.handleFilterChange} value={this.state.dataDa} style={{height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/> 
                                                </Col>
                                            </Row>
                                            <Row style={{borderBottom: "1px solid #011e41", marginBottom: "5px", paddingBottom: "5px", height: "90%"}}>
                                                <Col sm={2} className="d-flex align-items-center justify-content-start">
                                                    <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>a:</h4>                                                    
                                                </Col>
                                                <Col sm={6} className="d-flex align-items-center justify-content-start">
                                                    <Input id="dataA" name="dataA" type="date" onChange={this.handleFilterChange} value={this.state.dataA} style={{height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/> 
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="d-flex align-items-center justify-content-start">
                                                    <h3 style={{color: "#011e41", fontWeight: "bold", fontSize:"35px", margin: "0px"}}>Importo:</h3>
                                                </Col>
                                            </Row>
                                            <Row style={{marginBottom: "5px"}}>
                                                <Col sm={2} className="d-flex align-items-center justify-content-start">
                                                    <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>da:</h4>                                                    
                                                </Col>
                                                <Col sm={6} className="d-flex align-items-center justify-content-start">
                                                    <Input id="importoDa" name="importoDa" type="number" onChange={this.handleFilterChange} value={this.state.importoDa} style={{height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/> 
                                                </Col>
                                            </Row>
                                            <Row style={{borderBottom: "1px solid #011e41", marginBottom: "5px", paddingBottom: "5px"}}>
                                                <Col sm={2} className="d-flex align-items-center justify-content-start">
                                                    <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>a:</h4>                                                    
                                                </Col>
                                                <Col sm={6} className="d-flex align-items-center justify-content-start">
                                                    <Input id="importoA" name="importoA" type="number" onChange={this.handleFilterChange} value={this.state.importoA} style={{height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/> 
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="d-flex align-items-center justify-content-start">
                                                    <h3 style={{color: "#011e41", fontWeight: "bold", fontSize:"35px", margin: "0px"}}>Cliente:</h3>
                                                </Col>
                                            </Row>
                                            <Row style={{marginBottom: "5px"}}>
                                                <Col sm={2} className="d-flex align-items-center justify-content-start">
                                                    <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Codice Fiscale:</h4>                                                    
                                                </Col>
                                                <Col sm={6} className="d-flex align-items-center justify-content-start">
                                                    <Input id="codFisc" name="codFisc" type="text" onChange={this.handleFilterChange} value={this.state.codFisc} style={{height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/> 
                                                </Col>
                                            </Row>
                                            <Row style={{borderBottom: "1px solid #011e41", marginBottom: "5px", paddingBottom: "5px"}}>
                                                <Col sm={2} className="d-flex align-items-center justify-content-start">
                                                    <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Cliente:</h4>                                                    
                                                </Col>
                                                <Col sm={6} className="d-flex align-items-center justify-content-start">
                                                    <Input id="cliente" name="cliente" type="text" onChange={this.handleFilterChange} value={this.state.cliente} style={{height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/> 
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className="d-flex align-items-center justify-content-start">
                                                    <h3 style={{color: "#011e41", fontWeight: "bold", fontSize:"35px", margin: "0px"}}>Stato:</h3>
                                                </Col>
                                            </Row>
                                            <Row style={{marginBottom: "5px"}}>
                                                <Col sm={2} className="d-flex align-items-center justify-content-start">
                                                    <h4 style={{color: "#011e41", fontWeight: "bold", margin: "0px"}}>Stato:</h4>                                                    
                                                </Col>
                                                <Col sm={6} className="d-flex align-items-center justify-content-start">
                                                    <Input id="stato" name="stato" type="text" onChange={this.handleFilterChange} value={this.state.stato} style={{height: "35px", width: "100%", padding: "0px", textAlign: "center", color: "#011e41", borderColor: "#011e41"}}/> 
                                                </Col>
                                            </Row>
                                        </Container>
                                    </OrdiniFilter>
                                </Col>
                            </Row>
                        </Container>
                    </Col>
                </Row>   
            </Container>
        );

        const navFooter = (
            <Container className="d-flex align-items-center justify-content-center" style={{padding: "0px", paddingBottom: "15px"}} fluid>
                <Row style={{margin: "0px", width: "100%"}}>
                    <Col className="d-flex align-items-center justify-content-start col-6" style={{paddingLeft: "0px", color: "#011e41"}}>
                        {this.state.totalVersamenti !== 0 ? "Mostra da " + ((this.state.numPerPage*(this.state.pageNum-1))+1) + " a " + (this.state.numPerPage*this.state.pageNum <= this.state.totalVersamenti ? this.state.numPerPage*this.state.pageNum : this.state.totalVersamenti) + " di " + this.state.totalVersamenti + " risultati" : null}
                    </Col>
                    <Col className="d-flex align-items-center justify-content-end col-6" style={{paddingLeft: "0px", color: "#011e41"}}>
                        {this.state.pageNum === 1 ? null : <a style={{paddingRight: "10px", cursor: "pointer"}} onClick={this.handlePrev}>Indietro</a> }
                        {(this.state.pageNum === 1 && this.state.pageNum === this.state.totalVersamenti) || this.state.totalVersamenti === 0 ? null : this.state.pageNum}
                        {(this.state.pageNum === this.state.totalPages) || this.state.totalVersamenti === 0 ? <p style={{paddingLeft: "35px"}}></p> : <a style={{paddingLeft: "10px", cursor: "pointer"}} onClick={this.handleNext}>Avanti</a>}
                    </Col>
                </Row>
            </Container>
        );

        return (
            <Container fluid style={{color: "#011e41"}}> 
                {titolo}
                <Container>
                    <Row>
                        <Col>
                            <Table responsive borderless>
                                <thead>
                                    <tr style={{borderBottom: "1px solid #011e41"}}>
                                        <th style={{textAlign: "center"}}>Versamento ID</th>
                                        <th style={{textAlign: "center"}}>Codice Cliente</th>
                                        <th style={{textAlign: "center"}}>Cliente</th>
                                        <th style={{textAlign: "center"}}>Importo</th>
                                        <th style={{ textAlign: "center" }}>Data</th>
                                        {sessionStorage.getItem('selectedRole') == 'Amministrazione' ? <th style={{ textAlign: "center" }}>Agente</th>: null}
                                        <th style={{ textAlign: "center" }}>Stato</th>
                                        <th style={{textAlign: "center"}}>Fattura</th>
                                        <th style={{textAlign: "center"}}>Note</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.versamenti.map((versamento, index) => {
                                        return(
                                            <tr key={index}>
                                                <td style={{padding: "5px", textAlign: "center"}}>{versamento.versamentoId}</td>
                                                <td style={{padding: "5px", textAlign: "center"}}>{versamento.cliente.codiceCliente}</td>
                                                <td style={{padding: "5px", textAlign: "center"}}>{versamento.cliente.ragSoc}</td>
                                                <td style={{padding: "5px", textAlign: "center"}}>€ {versamento.importo}</td>
                                                <td style={{padding: "5px", textAlign: "center"}}>{new Date(versamento.dataVersimento).toLocaleDateString()}</td>
                                                {sessionStorage.getItem('selectedRole') == 'Amministrazione' ? <td style={{ padding: "5px", textAlign: "center" }}>{versamento.agente}</td> : null}
                                                <td style={{ padding: "5px", textAlign: "center" }}>{versamento.status}</td>
                                                <td style={{padding: "5px", textAlign: "center"}}>{versamento.fattura}</td>
                                                <td style={{padding: "5px", textAlign: "center"}}>{versamento.note}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Container>
                {navFooter} 
            </Container>
        )
    }
}
//test
export default withRouter(StoricoVersamentoContainer)

//<td style={{padding: "5px", textAlign: "center"}}><a style={{padding: "0", color: "blue", cursor: "pointer"}} onClick={(e) => this.getPdf(e, versamento.fattura.fatturaId)}>{versamento.fattura.fatturaId}</a></td>


// WEBPACK FOOTER //
// ./src/containers/StoricoVersamentoContainer.js